import type { FC, ReactNode } from 'react';
import { Button } from '@interstate/components/Button';
import { Typography } from '@interstate/components/Typography';
import { ResultsHeaderContainer } from './search.styles';

export interface SearchResultsHeaderProps {
    testIdPrefix: string;
    resultCount: number;
    addNewLabel: string;
    addNewIcon: ReactNode;
    onAddNew: () => void;
}

const SearchResultsHeader: FC<SearchResultsHeaderProps> = ({ testIdPrefix, resultCount, addNewLabel, addNewIcon, onAddNew }) => (
    <ResultsHeaderContainer>
        <Typography variant="h6">{!resultCount ? 'No Results Found' : `Results: ${resultCount}`}</Typography>
        <Button
            data-testid={`${testIdPrefix}-add-new-button`}
            buttonStyle="tertiary"
            size="small"
            startIcon={addNewIcon}
            onClick={onAddNew}
        >
            {addNewLabel}
        </Button>
    </ResultsHeaderContainer>
);

export default SearchResultsHeader;
